import React from "react";
import { IconProps } from "../types";

const QrCodeIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="19"
        height="18"
        fill="none"
        viewBox="0 0 19 18"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M7.25 8.5H4.25C3.285 8.5 2.5 7.715 2.5 6.75V3.75C2.5 2.785 3.285 2 4.25 2H7.25C8.215 2 9 2.785 9 3.75V6.75C9 7.715 8.215 8.5 7.25 8.5ZM4.25 3.5C4.112 3.5 4 3.612 4 3.75V6.75C4 6.888 4.112 7 4.25 7H7.25C7.388 7 7.5 6.888 7.5 6.75V3.75C7.5 3.612 7.388 3.5 7.25 3.5H4.25Z"
          fill={color}
        />
        <path
          d="M14.75 8.5H11.75C10.785 8.5 10 7.715 10 6.75V3.75C10 2.785 10.785 2 11.75 2H14.75C15.715 2 16.5 2.785 16.5 3.75V6.75C16.5 7.715 15.715 8.5 14.75 8.5ZM11.75 3.5C11.612 3.5 11.5 3.612 11.5 3.75V6.75C11.5 6.888 11.612 7 11.75 7H14.75C14.888 7 15 6.888 15 6.75V3.75C15 3.612 14.888 3.5 14.75 3.5H11.75Z"
          fill={color}
        />
        <path
          d="M7.25 16H4.25C3.285 16 2.5 15.215 2.5 14.25V11.25C2.5 10.285 3.285 9.5 4.25 9.5H7.25C8.215 9.5 9 10.285 9 11.25V14.25C9 15.215 8.215 16 7.25 16ZM4.25 11C4.112 11 4 11.112 4 11.25V14.25C4 14.388 4.112 14.5 4.25 14.5H7.25C7.388 14.5 7.5 14.388 7.5 14.25V11.25C7.5 11.112 7.388 11 7.25 11H4.25Z"
          fill={color}
        />
        <path d="M6.5 4.5H5V6H6.5V4.5Z" fill={color} />
        <path d="M14 4.5H12.5V6H14V4.5Z" fill={color} />
        <path d="M6.5 12H5V13.5H6.5V12Z" fill={color} />
        <path d="M16.5 14.5H15V16H16.5V14.5Z" fill={color} />
        <path d="M15 13H13.5V14.5H15V13Z" fill={color} />
        <path d="M16.5 11.5H15V13H16.5V11.5Z" fill={color} />
        <path d="M13.5 14.5H11.5V16H13.5V14.5Z" fill={color} />
        <path d="M11.5 11.5H10V14.5H11.5V11.5Z" fill={color} />
        <path d="M15 10H11.5V11.5H15V10Z" fill={color} />
      </svg>
    );
  },
);

export default QrCodeIcon;
